<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('discountPayment.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('discountPayment.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3 col-sm-4">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('discountPayment.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('yearlyPaymentList.branchName')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.branch_id"
                        :options="branches"
                        @change="onBranchChange"
                      ></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>{{ $t('discountPayment.class') }}</label>
                        <treeselect
                          :options="class_options"
                          :placeholder="$t('all')"
                          :multiple="true"
                          :limit="1"
                          v-model="model.class_id"
                          :maxHeight="150"
                        ></treeselect>
                        <div class="validate" v-if="errors.has('class_id')">
                          {{ errors.first('class_id') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>{{ $t('discountPayment.discountType') }}</label>
                        <treeselect
                          :options="[
                            { id: '%', label: '%'},
                            { id: '$', label: '$'},
                          ]"
                          :placeholder="$t('all')"
                          :multiple="true"
                          v-model="model.dis_type"
                          :maxHeight="150"
                        ></treeselect>
                        <div class="validate" v-if="errors.has('dis_type')">
                          {{ errors.first('dis_type') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="required">{{
                          $t('discountPayment.discountDate')
                        }}</label>
                        <a-range-picker
                          format="DD-MM-YYYY"
                          :defaultValue="rangeDate"
                          :defaultPickerValue="rangeDate"
                          @change="dateRangeChange"
                        >
                          <template slot="renderExtraFooter"></template>
                        </a-range-picker>
                        <div class="validate" v-if="errors.has('date_range')">
                          {{ errors.first('date_range') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('discountPayment.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'discountPayment',
  data () {
    return {
      loading: false,
      waiting: false,
      errors: new Errors(),
      class_options: [],
      branches: [],
      src: '',
      rangeDate: [moment(), moment()],
      model: {
        branch_id: null,
        class_id: [],
        dis_type: []
      }
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportPayment', [
      'getBranch',
      'discountPayment',
      'getClass'
    ]),
    moment,
    async fetchData () {
      this.loading = true
      await this.getBranch()
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
          this.model.branch_id = this.$store.state.authUser.default_branch_id
          this.onBranchChange()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    onBranchChange () {
      this.class_options = []
      this.model.class_id = []
      this.loading = true
      this.getClass({
        filter: {
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.class_options = _.sortBy(response.data, ['class_name']).map(
            el => ({
              id: el.class_id,
              label:
                el.class_name +
                ' | ' +
                (el.teacher ? el.teacher.full_name_en + ' | ' : '') +
                el.academic_study_time.study_time
            })
          )
          this.model.class_id = []
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    dateRangeChange (dateRange) {
      this.$store.commit(
        'reportPayment/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'reportPayment/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
    },
    preview () {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.discountPayment(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
